// js
import { connect } from 'react-redux';
import DataSourcesByArea from '../../components/analytics/DataSourcesByArea';
import { makeGetAllSubAreasSourcesStats } from '../../selectors/analytics/overviewSelectors';
import { getTotalDataPerDayForCompletedActiveConfiguredItems } from '../../selectors/dsa/sourcesSelectors';


const mapStateToProps = (state) => {
  const getAllSubAreasSourcesStats = makeGetAllSubAreasSourcesStats();

  return {
    stats: getAllSubAreasSourcesStats(state),
    totalDataPerDay: getTotalDataPerDayForCompletedActiveConfiguredItems(state),
    pptxTarget: 'pptx_data_sources_by_area'
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSourcesByArea);



// WEBPACK FOOTER //
// ./src/containers/analytics/DataSourcesByArea.js